module.exports = __webpack_public_path__ + "static/media/plan-wom-150-gigas-wom86.a6d95cd2.svg";